(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name                 : 'BucketManage',
		confirm_before_submit: true
	};

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/Buckets/manage', function onload() {
			Adzuki.Form.registerForm(form);
		});
	});

	form.load = function load($form)
	{
		$('.bulk-action').click(function changeBulkAction(e) {
			var form_action = $(this).data("form-action");

			e.preventDefault();

			$('#bucketmanage-form_action').val(form_action);

			$form.submit();
		});

		$('.view-bucket').click(function showBucketUI(e) {
			var bucket_id = $(this).data("id");

			e.preventDefault();

			Adzuki.Buckets.openBuckets(bucket_id);
		});
	};
}(jQuery, window.Adzuki || {}));
